// pages/RequestPasswordResetPage.js

import React, { useState } from 'react';
import styled from 'styled-components';
import axios from '../services/axios';

const Container = styled.div`
  max-width: 400px;
  margin: 4rem auto;
  padding: 2rem;
  border-radius: 12px;
  background: ${({ theme }) => theme.cardBackground || '#fefefe'};
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  font-family: ${({ theme }) => theme.fontFamily || 'inherit'};
`;

const Title = styled.h2`
  margin-bottom: 1.5rem;
  text-align: center;
  color: ${({ theme }) => theme.primaryColor || '#007bff'};
`;

const Input = styled.input`
  width: 100%;
  margin-bottom: 1rem;
  padding: 0.75rem;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-family: ${({ theme }) => theme.fontFamily || 'inherit'};
`;

const Button = styled.button`
  width: 100%;
  padding: 0.75rem;
  border: none;
  background-color: ${({ theme }) => theme.primaryColor || '#007bff'};
  color: white;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: background-color 0.3s;

  &:hover {
    background-color: ${({ theme }) => theme.primaryHover || '#0056b3'};
  }
`;

const Message = styled.p`
  margin-top: 1rem;
  color: ${({ error }) => (error ? 'red' : 'green')};
  font-weight: 500;
`;

const RequestPasswordResetPage = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);
    try {
      await axios.post('/api/password-reset/', { email });
      setMessage('Check your email for the password reset link.');
      setError(false);
    } catch {
      setMessage('Error: Email not found or failed to send.');
      setError(true);
    }
  };

  return (
    <Container>
      <Title>Reset Your Password</Title>
      <form onSubmit={handleSubmit}>
        <Input
          type="email"
          placeholder="Enter your email"
          value={email}
          required
          onChange={(e) => setEmail(e.target.value)}
        />
        <Button type="submit">Send Reset Link</Button>
      </form>
      {message && <Message error={error}>{message}</Message>}
    </Container>
  );
};

export default RequestPasswordResetPage;
